<template>
    <div class="create-exam" v-loading.fullscreen="loading">
        <el-row type="flex" align="middle" style="padding: 14px 20px;">
            <el-page-header content="快捷创建考试" v-if="isShowPageHeader" @back="$router.go(-1)"></el-page-header>
            <manage-title v-else style="padding: 0 10px">发布考试</manage-title>
            <navbar v-model="step" style="flex: 1;margin-left: 70px"/>
        </el-row>

<!--        <el-steps :active="step" align-center style="margin-top: 32px">-->
<!--            <el-step title="考场设置"></el-step>-->
<!--            <el-step title="选择试卷"></el-step>-->
<!--            <el-step title="选择考生"></el-step>-->
<!--        </el-steps>-->

        <div v-if="step === 1" v-loading="initFlag" class="step">
            <el-form
                :model="form"
                ref="form"
                label-width="100px"
                label-position="right"
                :rules="rules"
            >
                <el-form-item label="名称" prop="ExamName">
                    <el-input
                        v-model="form.ExamName"
                        placeholder="请填写考试名称"
                        style="width: 500px;"
                    ></el-input>
                </el-form-item>
                <el-form-item label="考试类型">
                    <el-radio-group v-model="form.ExamType">
                        <el-radio :label="1" border size="mini">考试</el-radio>
                        <el-radio :label="2" border size="mini">作业</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="所属分类" prop="Category">
                    <medical-class-selector
                        v-model="form.Category"
                        :add-all="false"
                        style="width: 500px;">
                    </medical-class-selector>
                </el-form-item>
                <el-form-item label="考试须知" prop="Remark">
                    <el-input
                        v-model="form.Remark"
                        placeholder="请填写考试须知"
                        type="textarea"
                        style="width: 500px;"
                        :autosize="{ minRows: 4, maxRows: 8 }"
                    ></el-input>
                </el-form-item>
                <el-form-item label="考场密码">
                    <el-input
                        v-model="form.ExamPass"
                        placeholder="请设置考场密码"
                        style="width: 500px;"
                    ></el-input>
                </el-form-item>
                <el-form-item label="考试时间" prop="_timeRange">
                    <zj-date-picker2
                        v-model="form._timeRange"
                        type="datetimerange"
                        disabled="before"
                        :default-time="['00:00:00', '23:59:59']"
                        :current-date-add-minutes="15"
                        style="width: 500px;">
                    </zj-date-picker2>
                </el-form-item>
<!--                <el-form-item label="阅卷老师" prop="Teacher">-->
<!--                    <el-select v-model="form.Teacher" multiple filterable>-->
<!--                       <el-option v-for="item in teacherList" :value="item.value" :label="item.label" :key="item.value"/>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item>
                    <div slot="label">
                        答卷时长
                        <help-icon content="数字为0表示无限制"></help-icon>
                    </div>
                    <el-input-number
                        v-model="form.ExamTime"
                        :min="0"
                        @blur="form.ExamTime = form.ExamTime || 0"
                    ></el-input-number>
                    分钟
                </el-form-item>
                <el-form-item>
                    <div slot="label">
                        考试次数
                        <help-icon content="数字为0表示无限制"></help-icon>
                    </div>
                    <el-input-number
                        v-model="form.ExamNum"
                        :min="0"
                        @blur="form.ExamNum = form.ExamNum || 0"
                    ></el-input-number>
                    次
                </el-form-item>
                <el-form-item>
                    <div slot="label">
                        考场控制
                        <help-icon content="数字为0表示无限制"></help-icon>
                    </div>
                    <div class="xy-start" style="display:inline">
                        <div style="margin-bottom: 10px">
                            <el-input-number
                                v-model="form.MaxLastTime"
                                :min="0"
                                @blur="form.MaxLastTime = form.MaxLastTime || 0"
                                style=""
                            ></el-input-number>
                            分钟后，禁止参考
                        </div>
                        <div>
                            <el-input-number
                                v-model="form.MinExamTime"
                                :min="0"
                                @blur="form.MinExamTime = form.MinExamTime || 0"
                                style=""
                            ></el-input-number>
                            分钟内，禁止交卷
                        </div>
                        <div>
                            <el-checkbox
                                v-model="form.SubjectRank"
                                :true-label="1"
                                :false-label="0"
                                >试题乱序</el-checkbox
                            >
                            <el-checkbox
                                v-model="form.AnswerRank"
                                :true-label="1"
                                :false-label="0"
                                >选项乱序</el-checkbox
                            >
                            <el-checkbox
                                v-model="form.IsAbExamPaperMode"
                                :true-label="1"
                                :false-label="0"
                            >AB卷</el-checkbox
                            >
                            <el-checkbox
                                v-model="form.IsCopy"
                                :true-label="1"
                                :false-label="0"
                            >限制答案粘贴</el-checkbox
                            >
                            <el-checkbox
                                v-model="form.IsFullScreen"
                                :true-label="1"
                                :false-label="0"
                            >切屏后强制交卷</el-checkbox>
                            <el-checkbox
                                v-model="form.PassAgain"
                                :true-label="1"
                                :false-label="0">及格后不能再考</el-checkbox
                            >
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="成绩发布" prop="PublishTime">
                    <el-radio-group v-model="form.ScorePublish">
                        <el-radio :label="1">永不发布</el-radio>
                        <el-radio :label="3">阅卷后发布</el-radio>
                        <el-radio :label="2">
                            指定发布时间
                            <el-date-picker
                                v-model="form.PublishTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                :disabled="form.ScorePublish !== 2"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="答案查看" prop="IsCheckScore">
                    <el-checkbox v-model="form.IsCheckScore" :true-label="1" :false-label="0">
                        交卷后允许查看答案（“永不发布”时无效）
                    </el-checkbox>
                </el-form-item>
            </el-form>
            <div class="xy-center">
                <el-button type="primary" @click="toStep2">下一步</el-button>
            </div>
        </div>
        <div v-else-if="step === 2" class="step">
            <el-table :data="selectPapers" style="width: 100%;margin-top: 10px">
                <el-table-column prop="ExamName" label="试卷名称"/>
                <el-table-column prop="SubjectNum" label="题量">
                </el-table-column>
                <el-table-column prop="TotalScore" label="总分">
                </el-table-column>
                <el-table-column prop="PassScore" label="及格分">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="260">
                    <template v-slot="scope">
                        <el-button
                            @click="removePaper(scope.row)"
                            type="danger"
                            size="mini"
                            >删除</el-button
                        >
                        <el-button
                            @click="editPaper(scope.row)"
                            type="primary"
                            size="small">编辑</el-button>
                        <el-tooltip effect="dark" content="选择试卷库里的试卷创建考试" placement="top" v-if="form.IsAbExamPaperMode === 1">
                            <el-button
                                type="primary"
                                size="mini"
                                @click="$refs.selectPaper.open()">再选试卷</el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <div  slot="empty">
                    <img src="@/assets/img/admin/no-select-paper.png" alt="no-select-paper" style="margin: 20px 0"/>
                    <div class="font-size16 font-medium c-2F3134">请给这场考试添加试卷，选择以下方式添加</div>
                    <el-tooltip effect="dark" content="专业题库，机构自主组卷" placement="top">
                        <button class="btn-reset add-btn" @click="$router.push({
                        path: '/manage/resource/addPaper',
                        query: {
                            type: 'quickExam'
                        }
                        })">
                            <img src="@/assets/img/admin/add-paper.png" alt="custom-paper" width="16px" height="16px"/>
                            <span style="vertical-align: middle">自主组卷</span>
                        </button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="一键模版导入，快速添加试卷" placement="top">
                        <button class="btn-reset add-btn"  @click="$refs.paperTemplate.open()">
                            <img src="@/assets/img/admin/add-paper.png" alt="custom-paper" width="16px" height="16px"/>
                            <span style="vertical-align: middle">导入试卷</span>
                        </button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="选择试卷库里的试卷创建考试" placement="top">
                        <button class="btn-reset add-btn" @click="$refs.selectPaper.open()">
                            <img src="@/assets/img/admin/add-paper-2.png" alt="custom-paper" width="16px" height="16px"/>
                            <span style="vertical-align: middle">选择试卷</span>
                        </button>
                    </el-tooltip>
                </div>
            </el-table>
            <div class="xy-center" style="margin-top: 30px">
                <el-button type="primary" @click="step = 1">上一步</el-button>
                <el-button type="primary" @click="toStep3">下一步</el-button>
            </div>
        </div>
        <div v-else-if="step === 3" class="step">
            <template v-if="userTotal > 0">
                <el-form :model="step3Form">
                    <el-form-item label="参考人员">
                        <el-radio-group v-model="step3Form.memberType">
                            <el-radio label="pt_all">平台所有人员</el-radio>
                            <el-radio label="jg_all">本机构下所有人员</el-radio>
                            <el-radio label="members">指定人员</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <!-- 指定人员列表 START -->
                <div v-if="step3Form.memberType === 'members'">
                    <el-button type="primary" @click="$refs.selectMember.open()">选择用户组/人员</el-button>
                    <h3>已选择用户组</h3>
                    <el-table :data="step3Form.groups">
                        <el-table-column label="组名称" prop="Name">
                        </el-table-column>
                        <el-table-column label="操作" width="100">
                            <template v-slot="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="removeItem(scope.row, step3Form.groups)"
                                >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <h3>已选择用户</h3>
                    <el-table :data="step3Form.users">
                        <el-table-column
                            label="真实姓名"
                            prop="RealName"
                        ></el-table-column>
                        <el-table-column
                            label="账号"
                            prop="UserName"
                        ></el-table-column>
                        <el-table-column
                            label="电话"
                            prop="Telephone"
                        ></el-table-column>
                        <el-table-column
                            label="所属用户组"
                            :formatter="defaultVal"
                            prop="GroupName"
                        ></el-table-column>
                        <el-table-column label="操作" width="100">
                            <template v-slot="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="removeItem(scope.row, step3Form.users)"
                                >删除</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 指定人员列表 END -->
                <div class="xy-center" style="margin-top: 30px">
                    <el-button type="primary" @click="step = 2">上一步</el-button>
                    <el-button type="primary" @click="publish">发布</el-button>
                </div>
            </template>
            <template v-else>
                <div class="yx-center">
                    <img src="@/assets/img/admin/no-select-paper.png" alt="no-select-paper" style="margin: 20px 0"/>
                    <div class="font-size14 font-medium">您还没有学员，请添加学员</div>
                    <div style="margin: 20px 0">
                        <el-button type="primary" icon="el-icon-plus" size="small" @click="$refs.userImport.open()">批量导入</el-button>
                        <el-button type="default" icon="el-icon-circle-plus-outline"  size="small" @click="$refs.addUser.open()">新增用户</el-button>
                    </div>
                </div>
            </template>
        </div>
        <select-paper-dialog
            ref="selectPaper"
            @result="onSelectPaper"
            :max-select="form.IsAbExamPaperMode === 1 ? 2 : 1"
            :default-selected="selectPapers"
        ></select-paper-dialog>
        <select-member-dialog
            ref="selectMember"
            :selected-group="selectedGroup"
            :selected-member="step3Form.users"
            @select-user="onSelectUser"
            @select-group="onSelectGroup"
        ></select-member-dialog>
        <quick-user-import ref="userImport" @importSuccess="onImportSuccess"/>
        <quick-template-paper ref="paperTemplate" @confirm="handleConfirm"/>
        <edit-paper ref="editPaper" @updatePaper="onUpdatePaper"/>
        <add-user ref="addUser" @importSuccess="onImportSuccess"/>
    </div>
</template>

<script>
import HelpIcon from "@/components/manager/HelpIcon";
import SelectPaperDialog from "@/components/manager/create-exam/SelectPaperDialog";
import SelectMemberDialog from "@/components/manager/create-exam/SelectMemberDialog";
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import ManageTitle from "@/components/manager/ManageTitle";
import { isEmpty } from "lodash";
import { ExamCreate, examGetById, ExamUpdate, fetchPaperDetails } from "@/api/manage";
import { getTeacherList } from "@/api/new-question-iteration/create-exam";
import QuickTemplatePaper from "@/views/manage/exam/cpns/quick-template-paper";
import Navbar from "./cpns/navbar"
import EditPaper from "@/views/manage/exam/cpns/editPaper";
import { GetOrganLevelInfo, GetOrganUser } from "@/api/organ";
import quickUserImport from "@/views/manage/exam/cpns/quick-userImport";
import addUser from "@/views/manage/exam/cpns/addUser";
import ZjDatePicker2 from "@/components/ZjDatePicker/ZjDatePicker"
export default {
    name: "create-exam",
    components: {
        ManageTitle,
        MedicalClassSelector,
        SelectMemberDialog,
        SelectPaperDialog,
        HelpIcon,
        Navbar,
        QuickTemplatePaper,
        EditPaper,
        quickUserImport,
        addUser,
        ZjDatePicker2
    },
    data(vm) {
        return {
            loading: false,
            initFlag: false,
            step: Number(vm.$route.query.currentStep) || 1,
            form: {
                ExamName: "",
                ExamType: 1,
                Category: "",
                Remark: "",
                ExamPass: "",
                BeginTime: "",
                EndTime: "",
                ExamTime: 120,
                ExamNum: 1,
                MaxLastTime: 0,
                MinExamTime: 0,
                SubjectRank: 0,
                AnswerRank: 0,
                PassAgain: 0,
                ScorePublish: 3,
                IsCheckScore: 0,
                PublishTime: "",
                _timeRange: [],
                Teacher: [],
                IsAbExamPaperMode: 0,
                IsCopy: 0,
                IsFullScreen: 0,
                ReadPaperPublish: 0
            },
            step3Form: {
                memberType: "jg_all",
                users: [],
                groups: []
            },
            selectPapers: [],
            remoteData: {},
            teacherList: [], // 阅卷老师列表
            isShowPageHeader: false,
            userTotal: 0
        };
    },
    watch: {
        "form._timeRange": {
            handler(newValue) {
                this.form.BeginTime = newValue[0];
                this.form.EndTime = newValue[1];
            }
        }
    },
    computed: {
        rules() {
            let that = this;
            function publishTimeValid(rule, val, cb) {
                if (that.form.ScorePublish === 2) {
                    if (val == null || val.length === 0) {
                        cb(new Error("请选择发布时间"));
                    } else {
                        let s = new Date(val);
                        if (s < new Date()) {
                            cb(new Error("发布时间必须大于当前时间"));
                        } else {
                            cb();
                        }
                    }
                } else {
                    cb();
                }
            }
            return {
                ExamName: [
                    {
                        required: true,
                        message: "请填写考试名称",
                        trigger: "blur"
                    }
                ],
                Category: [
                    {
                        required: true,
                        message: "请选择考试类别",
                        trigger: "change"
                    }
                ],
                _timeRange: [
                    {
                        required: true,
                        message: "请选择考试时间",
                        trigger: "change"
                    }
                ],
                PublishTime: [
                    { validator: publishTimeValid, trigger: "change" }
                ]
            };
        },
        isCreate() {
            return isEmpty(this.$route.query.id);
        },
        selectedGroup() {
            return this.step3Form.groups.map((el) => el.ID);
        }
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            vm.isShowPageHeader = from.name === "manage-index"
            if (from.name === "addPaper" || from.name === "ManagePaperImport") {
                const examInfo = window.sessionStorage.getItem("examInfo")
                if (examInfo) {
                    vm.form = Object.assign(vm.form, JSON.parse(examInfo))
                }
            }
        })
    },
    created() {
        const paperId = this.$route.query.paperId
        if (paperId) {
            this.getPaperDetail(paperId)
        }
    },
    mounted() {
        if (!this.isCreate) {
            this.loadDetail();
        }
        // 获取阅卷老师
        this.getTeacherList()
        this.GetOrganUser()
    },
    methods: {
        // 获取机构用户信息
        async GetOrganUser() {
            try {
                this.loading = true;
                const { data } = await GetOrganUser({
                    pageIndex: 1,
                    pageSize: 10,
                    keyWord: "",
                    sortBy: "ModifyTime",
                    sortOrder: "desc",
                    ManageType: 2
                });
                this.userTotal = data.count;
            } catch (err) {
                this.$toast("获取失败");
            }
            this.loading = false;
        },
        toStep2() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.step = 2;
                    window.sessionStorage.setItem("examInfo", JSON.stringify(this.form))
                }
            });
        },
        defaultVal(row, column, cellValue, index) {
            if (cellValue == null || cellValue === "" || cellValue.length === 0 || cellValue === "1753-01-01 00:00:00") {
                return "--"
            } else {
                return cellValue
            }
        },
        toStep3() {
            if (this.selectPapers.length < 1) {
                this.$message("请选择试卷");
                return;
            }
            this.step = 3;
        },
        // 删除已选试卷
        removePaper(paper) {
            let index = this.selectPapers.indexOf(paper);
            this.selectPapers.splice(index, 1);
        },
        /// 从列表中移除项目
        removeItem(item, list) {
            let index = list.indexOf(item);
            list.splice(index, 1);
        },
        // 打开选择试卷弹窗
        onSelectPaper(arr) {
            this.selectPapers = arr;
        },
        onSelectUser(users) {
            this.step3Form.users = users;
        },
        onSelectGroup(groups) {
            this.step3Form.groups = groups;
        },
        // 构建考试数据
        buildModel() {
            let model = {
                ExamName: this.form.ExamName,
                ClassId: this.form.Category,
                Remark: this.form.Remark,
                ExamPass: this.form.ExamPass,
                BeginTime: this.form.BeginTime,
                EndTime: this.form.EndTime,
                ExamTime: this.form.ExamTime,
                ExamNum: this.form.ExamNum,
                MaxLastTime: this.form.MaxLastTime,
                MinExamTime: this.form.MinExamTime,
                SubjectRank: this.form.SubjectRank,
                AnswerRank: this.form.AnswerRank,
                PassAgain: this.form.PassAgain,
                ScorePublish: this.form.ScorePublish,
                PublishTime: this.form.PublishTime,
                IsCheckScore: this.form.IsCheckScore,
                ExamType: this.form.ExamType,
                TeacherList: this.form.Teacher,
                IsCopy: this.form.IsCopy,
                IsFullScreen: this.form.IsFullScreen,
                IsAbExamPaperMode: this.form.IsAbExamPaperMode
            };
            model.CustomExamPapers = this.selectPapers.map((p) => {
                return { ExamPaperId: p.ExamPaperId };
            });
            // 用户组数据组装
            switch (this.step3Form.memberType) {
            case "pt_all":
                model.CustomExamJoinGroup = [{ OrganGroupId: -2 }];
                model.JoinPeopleNew = [];
                break;
            case "jg_all":
                model.CustomExamJoinGroup = [{ OrganGroupId: -1 }];
                model.JoinPeopleNew = [];
                break;
            case "members":
                // 选择的用户组数据封装
                model.CustomExamJoinGroup = this.selectedGroup.map(
                    (item) => {
                        return { OrganGroupId: item };
                    }
                );
                // 选择的用户数据组装
                model.JoinPeopleNew = this.step3Form.users.map((item) => {
                    return { UserId: item.UserId };
                });
                break;
            }
            if (!this.isCreate) {
                model.ExamId = this.$route.query.id;
            }
            return model;
        },
        publish() {
            let model = this.buildModel();
            if (
                model.JoinPeopleNew.length < 1 &&
                model.CustomExamJoinGroup.length < 1
            ) {
                this.$message.error("请选择参考人员或用户组");
                return;
            }
            this.loading = true;
            let req = this.isCreate ? ExamCreate : ExamUpdate;
            req({ examModel: encodeURI(JSON.stringify(model)) })
                .then((res) => {
                    this.$message.success(
                        this.isCreate ? "创建成功" : "编辑成功"
                    );
                    this.$router.replace({ name: "exam-list" });
                })
                .catch((err) => {
                    console.log("网络错误", err);
                    // this.$message.error(err.msg);
                })
                .finally(() => {
                    this.loading = false;
                });
            console.log(model);
        },
        // 加载考试详情
        async loadDetail() {
            this.initFlag = true;
            this.remoteData = await examGetById({
                id: this.$route.query.id
            });
            this.form.ExamName = this.remoteData.ExamName;
            this.form.ExamType = this.remoteData.ExamType;
            this.form.Category = this.remoteData.ClassId;
            this.form.Remark = this.remoteData.Remark;
            this.form.ExamPass = this.remoteData.ExamPass;
            this.form._timeRange = [
                this.remoteData.BeginTime,
                this.remoteData.EndTime
            ];
            this.form.BeginTime = this.remoteData.BeginTime;
            this.form.EndTime = this.remoteData.EndTime;
            this.form.ExamTime = this.remoteData.ExamTime;
            this.form.ExamNum = this.remoteData.ExamNum;
            this.form.MaxLastTime = this.remoteData.MaxLastTime;
            this.form.MinExamTime = this.remoteData.MinExamTime;
            this.form.SubjectRank = this.remoteData.SubjectRank;
            this.form.AnswerRank = this.remoteData.AnswerRank;
            this.form.PassAgain = this.remoteData.PassAgain;
            this.form.ScorePublish = this.remoteData.ScorePublish;
            this.form.PublishTime = this.remoteData.PublishTime;
            this.form.IsCheckScore = this.remoteData.IsCheckScore;
            this.form.IsAbExamPaperMode = this.remoteData.IsAbExamPaperMode;
            this.form.IsCopy = this.remoteData.IsCopy;
            this.form.IsFullScreen = this.remoteData.IsFullScreen;
            if (Array.isArray(this.remoteData.TeacherList)) {
                this.form.Teacher = this.remoteData.TeacherList;
            }
            this.selectPapers = this.remoteData.CustomExamPapers;

            // 组装用户组数据
            if (this.remoteData.CustomExamJoinGroup?.length === 1) {
                let group = this.remoteData.CustomExamJoinGroup[0];
                if (group.OrganGroupId === -2) {
                    this.step3Form.memberType = "pt_all";
                } else if (group.OrganGroupId === -1) {
                    this.step3Form.memberType = "jg_all";
                } else {
                    this.step3Form.memberType = "members";
                    this.step3Form.groups =
                        this.remoteData.CustomExamJoinGroup || [];
                }
            } else {
                this.step3Form.memberType = "members";
                this.step3Form.groups =
                    this.remoteData.CustomExamJoinGroup || [];
            }
            if (this.remoteData.JoinPeopleNew) {
                this.step3Form.users = this.remoteData.JoinPeopleNew;
            }
            this.step3Form.groups = this.step3Form.groups.map((el) => {
                return {
                    ID: el.OrganGroupId,
                    Name: el.GroupName
                };
            });

            this.initFlag = false;
        },
        /**
         * 获取阅卷老师列表
         * @return {undefined}
         */
        getTeacherList () {
            getTeacherList().then(res => {
                this.teacherList = (res || []).map(item => ({ label: item.RealName, value: item.ID }))
            })
        },

        // 获取试卷详情
        getPaperDetail (paperId) {
            fetchPaperDetails({ id: paperId }).then(res => {
                this.selectPapers.push(res)
            })
        },
        // 编辑试卷
        editPaper (row) {
            this.$confirm("编辑之后将会保留原来的试卷，并创建新的试卷，确定编辑吗？", "温馨提示", {
                type: "warning"
            }).then(res => {
                this.$refs.editPaper.open(row.ExamPaperId)
                this.tempExamPaperId = row.ExamPaperId
            })
        },
        onUpdatePaper (id) {
            const index = this.selectPapers.findIndex(item => item.ExamPaperId === this.tempExamPaperId)
            if (index >= 0) {
                this.selectPapers.splice(index, 1)
                this.getPaperDetail(id)
            }
        },
        // 确定
        handleConfirm (paperId) {
            this.getPaperDetail(paperId)
        },
        onImportSuccess () {
            this.GetOrganUser()
        }
    }
};
</script>

<style scoped lang="less">
.create-exam {
    .step {
        width: 80%;
        margin: 50px auto;
    }
}
.add-btn {
    border-radius: 4px;
    border: 1px solid #256CF4;
    padding: 6px 12px;
    margin-right: 20px;
    img {
        vertical-align: middle;
        margin-right: 4px;
    }
}
</style>
